/** @format */

import ApiService from "../../services/ApiService";
import { isLoading, setError } from "./uxAction";
import { parseServiceErrors } from "../../helpers/ParseServiceErrors";

export function createAccount(
  { firstName, lastName, email, accountType, password, sendEmailNotification },
  callback,
) {
  return async (dispatch) => {
    try {
      dispatch(isLoading(true));

      const resp = await ApiService.invokePost(
        process.env.REACT_APP_API_URL +
          `/proxy-api/admin/api/secured/accounts/`,
        {
          firstName,
          lastName,
          email,
          accountType: accountType?.toUpperCase(),
          password,
          email_notification: sendEmailNotification,
        },
      );

      dispatch(isLoading(false));

      if (resp.status >= 400 && resp.data?.details) {
        const parsedErrors = parseServiceErrors(resp.data);
        dispatch(setError(parsedErrors));
      } else {
        callback();
      }
    } catch (e) {
      dispatch(isLoading(false));
      dispatch(
        setError([{ param: "general", msg: "Unexpected error occurred." }]),
      );
    }
  };
}

export function updateAccount(
  {
    accountId,
    firstName,
    lastName,
    email,
    accountType,
    isFeatured,
    isActive,
    isEmailConfirmed,
  },
  callback,
) {
  return async (dispatch) => {
    try {
      dispatch(isLoading(true));

      await ApiService.invokePatch(
        process.env.REACT_APP_API_URL +
          `/admin/api/secured/accounts/${accountId}`,
        {
          firstName,
          lastName,
          email,
          accountType,
          isFeatured,
          isActive,
          isEmailConfirmed,
        },
      );

      setTimeout(() => {
        dispatch(isLoading(false));

        if (callback) callback();
      }, 1000);
    } catch (e) {}
  };
}

export function bulkDeleteAccount({ accountIds = [] }, callback) {
  return async (dispatch) => {
    try {
      dispatch(isLoading(true));

      const resp = await ApiService.invokePost(
        process.env.REACT_APP_API_URL +
          `/proxy-api/admin/api/secured/accounts/bulk_delete/`,
        {
          accountIds,
        },
      );

      setTimeout(() => {
        dispatch(isLoading(false));

        if (callback) callback();
      }, 1000);
    } catch (e) {}
  };
}

export function fetchAllAccount(
  {
    query,
    page = 0,
    limit = 3,
    accountType = "",
    isFeatured = "",
    orderBy = "",
    orderDirection = "",
  },
  callback,
) {
  return async (dispatch) => {
    const resp = await ApiService.invokeGet(
      process.env.REACT_APP_API_URL +
        `/proxy-api/admin/api/secured/accounts/?query=${query}&page=${page}&limit=${limit}&accountType=${accountType}&isFeatured=${isFeatured}&order_by=${orderBy}&order_direction=${orderDirection}`,
    );
    if (resp.status === 200) {
      const { data } = resp.data;
      await dispatch({
        type: "FETCH_ACCOUNT_TABLE",
        payload: data,
      });

      if (callback)
        callback({
          filteredData: data.filteredData,
          priceIds: data.priceIds,
          totalFiltered: data.filteredData.length,
          total: data.total,
        });
    }
  };
}

export function fetchAllCreatives() {
  return async (dispatch) => {
    const resp = await ApiService.invokeGet(
      process.env.REACT_APP_API_URL + `/admin/api/secured/account-creatives`,
    );
    if (resp.status === 200) {
      const { data } = resp.data;

      await dispatch({
        type: "FETCH_CREATIVES",
        payload: data.map((v) => ({
          id: v._id,
          text: `${v.firstName} ${v.lastName} | ${v.email}`,
        })),
      });
    }
  };
}

export function fetchAllCompanies() {
  return async (dispatch) => {
    const resp = await ApiService.invokeGet(
      process.env.REACT_APP_API_URL + `/admin/api/secured/account-companies`,
    );
    if (resp.status === 200) {
      const { data } = resp.data;

      await dispatch({
        type: "FETCH_COMPANIES",
        payload: data.map((v) => ({
          id: v._id,
          text: `${v.firstName} | ${v.email}`,
        })),
      });
    }
  };
}

export function getAccount({ id }, callback) {
  return async (dispatch) => {
    const resp = await ApiService.invokeGet(
      process.env.REACT_APP_API_URL + `/admin/api/secured/accounts/${id}`,
    );
    if (resp.status === 200) {
      const { data } = resp.data;

      if (callback) callback(data);
    }
  };
}

export function setAccountType(type) {
  return {
    type: "SET_ACCOUNT_TYPE",
    payload: type,
  };
}
